/**
 * The shortcut sheet. `?` opens it.
 *
 * The viewer is designed around the keyboard because this is a paging task,
 * so the list is part of the product rather than a courtesy (§10.4).
 */
import { Dialog } from '~/components/ui/overlay.tsx'
import { useT } from '~/i18n/index.tsx'

export function ShortcutsDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { t } = useT()

  const rows: [string[], string][] = [
    [['←', '→'], t('viewer.pageOf', { n: '−1', total: '+1' })],
    [['j', 'k'], t('viewer.page', { n: '±1' })],
    [['⇧', '←/→'], t('viewer.nextFailure')],
    [['1', '4'], t('fin.statement')],
    [['Home', 'End'], `${t('viewer.page', { n: 1 })} / ${t('viewer.page', { n: 'n' })}`],
    [['f'], t('viewer.fitWidth')],
    [['0'], t('viewer.fitPage')],
    [['d'], t('viewer.digits')],
    [['p'], t('viewer.pdf')],
    [['r'], t('viewer.raw')],
    [['?'], t('viewer.shortcuts')],
  ]

  return (
    <Dialog open={open} onClose={onClose} title={t('viewer.shortcuts')} width={420} closeLabel={t('action.close')}>
      <dl className="space-y-1.5">
        {rows.map(([keys, label], i) => (
          <div key={i} className="flex items-baseline gap-3">
            <dt className="flex w-24 shrink-0 gap-1">
              {keys.map((k) => (
                <kbd
                  key={k}
                  dir="ltr"
                  className="rounded-[3px] border border-[var(--border)] bg-[var(--bg-sunken)] px-1.5 py-px font-[family-name:var(--font-mono)] text-[length:var(--text-micro)] text-[var(--text-muted)]"
                >
                  {k}
                </kbd>
              ))}
            </dt>
            <dd className="text-[length:var(--text-data)] text-[var(--text)]">{label}</dd>
          </div>
        ))}
      </dl>
      <p className="mt-3 border-t border-[var(--border)] pt-2 text-[length:var(--text-micro)] text-[var(--text-faint)]">
        {t('viewer.syncScroll')}
      </p>
    </Dialog>
  )
}
